"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkStatementBatchGuarantorPatient_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var BulkStatementBatchGuarantor_1 = require("./BulkStatementBatchGuarantor");
var BulkStatementBatchGuarantorPatient_Factory = /** @class */ (function () {
    function BulkStatementBatchGuarantorPatient_Factory() {
    }
    BulkStatementBatchGuarantorPatient_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AdministrativeFeeWaived: model.AdministrativeFeeWaived,
            BatchGuarantorId: model.BatchGuarantorId,
            BulkStatementBatchGuarantor: BulkStatementBatchGuarantor_1.BulkStatementBatchGuarantor_Factory.CreateIncoming(model.BulkStatementBatchGuarantor),
            Excluded: model.Excluded,
            GuarantorPersonRecordId: model.GuarantorPersonRecordId,
            Notes: model.Notes,
            PatientRecordId: model.PatientRecordId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    BulkStatementBatchGuarantorPatient_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AdministrativeFeeWaived: model.AdministrativeFeeWaived,
            BatchGuarantorId: model.BatchGuarantorId,
            BulkStatementBatchGuarantor: BulkStatementBatchGuarantor_1.BulkStatementBatchGuarantor_Factory.CreateOutgoing(model.BulkStatementBatchGuarantor),
            Excluded: model.Excluded,
            GuarantorPersonRecordId: model.GuarantorPersonRecordId,
            Notes: model.Notes,
            PatientRecordId: model.PatientRecordId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return BulkStatementBatchGuarantorPatient_Factory;
}());
exports.BulkStatementBatchGuarantorPatient_Factory = BulkStatementBatchGuarantorPatient_Factory;
